'use client';

import { useMemo, useState } from 'react';
import type { Scope } from '@terra/shared-contracts-external-network';
import { EXTERNAL_SCOPE_PAGE_SIZE } from './scope-constants';
import type { ScopeFilter, ScopeSection } from './scope-types';

export type ExternalScopeNetblockListQuery = {
  limit: number;
  skip: number;
  scope?: Scope;
};

export function useExternalScopeListQuery() {
  const [activeSection, setActiveSection] = useState<ScopeSection>('netblocks');
  const [scopeFilter, setScopeFilter] = useState<ScopeFilter>('all');
  const [netblockSkip, setNetblockSkip] = useState(0);
  const netblockListQuery = useMemo<ExternalScopeNetblockListQuery>(
    () => ({
      limit: EXTERNAL_SCOPE_PAGE_SIZE,
      skip: netblockSkip,
      ...(scopeFilter !== 'all' ? { scope: scopeFilter } : {}),
    }),
    [scopeFilter, netblockSkip],
  );

  return {
    activeSection,
    setActiveSection,
    scopeFilter,
    setScopeFilter,
    netblockSkip,
    setNetblockSkip,
    netblockListQuery,
  };
}

export type ExternalScopeListQueryState = ReturnType<
  typeof useExternalScopeListQuery
>;
